<template>
  <div style="width:100%;padding: 0 10px;">     
      <tr style=" font-size: 15px;" :gutter="16">
        <th style="width: 60px;" class="bdtlb">
          <el-checkbox v-model="checked">全选</el-checkbox>
        </th>
         <th class="center gridcs bdtlb">床位号</th>
         <th class="center gridcs bdtlb">姓名</th>
         <th class="center gridcs bdtlb">住院号</th>
         <th class="center gridcs bdtlb">项目名称</th>
         <th class="center gridcs bdtlb">类别</th>
         <th class="center gridcs bdtlb">规格</th>
         <th class="center gridcs bdtlb">单价（元）</th>
         <th class="center gridcs bdtlb">数量</th>
         <th class="center gridcs bdtlb">总金额（元）</th>
         <th class="center gridcs bdtlb">医保类别</th>
         <th class="center gridcs bdtlb">执行科室</th>
         <th class="center gridcs bdtlb">开单人</th>
         <th class="center gridcs bdtlb">开单科室</th>
         <th class="center gridcs bdtlb bdr">开单时间</th>
      </tr>
      <div v-for="(item,index) in billList" :key="index">
        <tr v-if="!item.type || item.type != 'total'" style=" font-size: 15px;" :gutter="16" border>          
          <td  style="width: 60px;" class="center bdlb">
            <el-checkbox v-model="checked"></el-checkbox>
          </td>
           <td class="center gridcs bdlb">{{ item.bedNo }}</td>
           <td class="center gridcs bdlb">{{ item.patientName }}</td>
           <td class="center gridcs bdlb">{{ item.ipNo }}</td>
           <td class="center gridcs bdlb">{{ item.name }}</td>
           <td class="center gridcs bdlb">{{ item.rpClass }}</td>
           <td class="center gridcs bdlb">{{ item.standard }}</td>
           <td class="center gridcs bdlb">{{ item.price }}</td>
           <td class="center gridcs bdlb">{{ item.quantity }}</td>
           <td class="center gridcs bdlb">{{ item.price * item.quantity }}</td>
           <td class="center gridcs bdlb">{{ item.claimType }}</td>
           <td class="center gridcs bdlb">{{ item.execDeptCode | dictText("Dept") }}</td>
           <td class="center gridcs bdlb">{{ item.doctorName }}</td>
           <td class="center gridcs bdlb">{{ item.deptCode | dictText("Dept") }}</td>
           <td class="center gridcs bdlb bdr">{{ item.adviceTime | fmtDate }}</td>
        </tr>
        <tr v-else style="font-size: 15px;">
          <td class="bdlbr" style="text-align: right;width: 1755px;">患者本日费用总计：{{item.dayTotal}}元 &nbsp;&nbsp;&nbsp;&nbsp;费用累计：{{item.total}}元&nbsp;&nbsp;&nbsp;&nbsp;</td>
        </tr>
      </div>
      <div class="center" v-if="billList.length == 0" style="position:absolute; top: 50%;left: 50%;color: #909399;font-size: 14px;">暂无数据</div>
    </div>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props:{
    list:Array
  },
  components: {
  },
  data() {
    return {
      billList:[],
      checked:false,
      title: "",
    };
  },
  computed: {
  },
  watch: {
    list:{
      handler(newVal, oldVal) {
        this.show(newVal);
      },
      deep: true
    }
  },
  created() {
    // this.condition.execDeptCode = this.user.deptCode;
  },
  methods: {
    show(list){
      if(list.length>0){
        const groupByField = (field) => {
          return (accumulator, currentValue) => {
            const key = currentValue[field];
            if (!accumulator[key]) {
              accumulator[key] = [];
            }
            accumulator[key].push(currentValue);
            return accumulator;
          };
        };

        const groupedData = list.reduce(groupByField('ipNo'), {});
        console.log(groupedData);
        
        this.result(groupedData)
       
      }
    },
    result(groupedData){
      let result = []
        for (const key in groupedData) {
          if (groupedData.hasOwnProperty(key)) {
            const bills = groupedData[key];
            result = result.concat(bills);
            let dayTotal = 0
            if(bills.length>0){
              bills.forEach(bill => {
                dayTotal = dayTotal + bill.price * bill.quantity
              });
            }
            let item = {
              type:'total',
              ipNo:key,
              total:'',
              dayTotal
            }
            result.push(item)
          }
        }
        console.log(result);
        result.forEach(el=>{
          this.getAllTotal(el)
        })
        this.$set(this,"billList",result)
    },
    async getAllTotal(item){
      let params = {
        ipNo:item.ipNo
      }
      let res = await api.Hospitalization.query(params)
      console.log('res.items[0].amount===',res.items[0].amount)
      item.total = res.items[0].amount || '--'
    }
   
  },
};
</script>
<style >
.bdtlb{
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
.bdlbr{
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
.bdlb{
  border-bottom: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
.bdr {
  border-right: 1px solid #dcdfe6;
}
.bdb {
  border-bottom: 1px solid #dcdfe6;
}
.bdt {
  border-top: 1px solid #dcdfe6;
}
.bdl {
  border-left: 1px solid #dcdfe6;
}
tr,th,td{
  /* border: 1px solid #dcdfe6; */
  padding: 10px;
}
.gridcs{
  width: 100px;
  word-break: break-all;
}
</style>
